import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from 'react';

import { FolderSvg } from '../../StoryList/StoryListContent/FolderSvg';
import { styles } from './EmptyView.styles';

export type IEmptyViewProps = {
  title: string;
  description: string;
  showButton?: boolean;
  buttonTitle?: string;
  buttonVariant?: 'outlined' | 'contained' | 'text';
  buttonSize?: 'small' | 'medium' | 'large';
  buttonAction?(): void;
};

export const EmptyView: React.FC<IEmptyViewProps> = ({
  title,
  description,
  showButton,
  buttonSize,
  buttonTitle,
  buttonVariant,
  buttonAction
}) => {
  return (
    <Box sx={styles.centered}>
      <FolderSvg />
      {title && (
        <Typography variant="h2" data-test="section-welcome-heading" sx={styles.title}>
          {title}
        </Typography>
      )}
      <Typography variant="body2" sx={styles.description}>
        {description}
      </Typography>
      {showButton && (
        <Button
          size={buttonSize}
          variant={buttonVariant}
          data-test="empty-section-button"
          onClick={buttonAction}
        >
          {buttonTitle}
        </Button>
      )}
    </Box>
  );
};
